import { createFileRoute } from '@tanstack/react-router'
import { TermsPrivacySettings } from '@/features/organizations/settings/terms-privacy'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/terms-privacy'
)({
  component: TermsPrivacySettings,
})




